import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_SECRET_KEY;
const ENCRYPTION_KEY = process.env.REACT_APP_RESUMEX_SECRET_KEY;

const encryptData = (data) => {
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(data)), secretKey).toString();
  return encrypted;
};

const decryptData = (text) => {
  const bytes = CryptoJS.AES.decrypt(text, secretKey);
  const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decrypted;
};

const encryptForResumeX = (data) => {
  if (data) {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), ENCRYPTION_KEY || 'abc').toString();
    return encrypted;
  }
  return false;
};

const decryptForResumeX = (encrypted) => {
  if (encrypted) {
    try {
      const decrypted = CryptoJS.AES.decrypt(encrypted, ENCRYPTION_KEY || 'abc').toString(CryptoJS.enc.Utf8);
      return JSON.parse(decrypted);
    } catch (error) {
      if (
        error?.message?.includes('Malformed UTF-8 data') ||
        error?.message?.includes('Unexpected end of JSON input')
      ) {
        console.log('Error in token', error.message);
        return error.message;
      }
    }
  }
  return false;
};

export { encryptData, decryptData, encryptForResumeX, decryptForResumeX };
